"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_STORAGE_EXPIRY = exports.AUTH_TRIGGER_POST_LOGIN = exports.AUTH_STORAGE_KEY = exports.AUTH_CODE_PARAM = exports.AUTH_STATE_COOKIE_NAME = void 0;
exports.AUTH_STATE_COOKIE_NAME = 'oauth_state';
exports.AUTH_CODE_PARAM = 'code';
exports.AUTH_STORAGE_KEY = 'auth';
exports.AUTH_TRIGGER_POST_LOGIN = 'authTriggerPostLogin';
exports.AUTH_STORAGE_EXPIRY = 5 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=AuthConstants.js.map